import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { Buffer } from 'buffer';
import { v4 as uuidv4 } from 'uuid';
/**
 * Uploads a file to a temporary S3 bucket.
 * @param {File} selectedFile - The file to upload
 * @param {string} fileName - The name of the file
 * @param {string} fileType - The file type
 * @returns {Promise<{ url: string, id: string }>} The URL and ID of the uploaded file
 * @throws {Error} If the upload fails
 */
const uploadToTempS3Base64 = (selectedFile, fileName, fileType) =>
  new Promise((resolve, reject) => {
    let buff;
    if (selectedFile.result) {
      buff = Buffer.from(
        selectedFile.result.replace(/^data:image\/\w+;base64,/, '') ?? '',
        'base64',
      );
    } else if (selectedFile.file) {
      buff = Buffer.from(
        selectedFile.file.replace(/^data:image\/\w+;base64,/, '') ?? '',
        'base64',
      );
    } else if (typeof selectedFile === 'string') {
      buff = Buffer.from(
        selectedFile.replace(/^data:image\/\w+;base64,/, '') ?? '',
        'base64',
      );
    }

    // I need to only keep the last part of the file name
    const newFileName = fileName.split('/').pop();
    const filePath = fileName.split('/').slice(0, -1).join('/');
    const fileExtension = newFileName.split('.').pop();
    const correctFN = `${filePath}/${uuidv4()}.${fileExtension}`;

    const encodedFileName = correctFN;

    const upload = new Upload({
      client: new S3Client({
        region: import.meta.env.VITE_REGION ?? 'eu-west-1',
        credentials: {
          accessKeyId: import.meta.env.VITE_BUCKET_ACCESS_KEY,
          secretAccessKey: import.meta.env.VITE_BUCKET_SECRET_KEY,
        },
      }),

      params: {
        Bucket: import.meta.env.VITE_BUCKET_NAME,
        Key: encodedFileName,
        Body: buff,
        ContentEncoding: 'base64',
        ContentType: fileType,
      },
    });

    upload
      .done()
      .then((data) => {
        resolve({
          url: data.Location,
          id: data.Key,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });

export default uploadToTempS3Base64;
